module.exports = __webpack_public_path__ + "static/favicon-087c466921121552858d190939672c88.png";